import avatarPlaceHolder from 'gcs-common/img/user.svg';
import styles from './styles.module.scss';

const ProfileImageCell = ({ cell }) => {
  return (
    <div className={styles.profileImageWrapper}>
      <img className={styles.profileImage} src={cell.value || avatarPlaceHolder} alt="profil-bild" />
    </div>
  );
};

export default ProfileImageCell;
